<template>
  <div class="list">
    <van-nav-bar
      :border="false"
      @click-left="$store.dispatch('back')"
      placeholder
      :fixed="true"
      title="我的已购"
    >
      <template #left>
        <van-icon size="40rpx" name="arrow-left" color="#333" />
      </template>
    </van-nav-bar>
    <van-tabs @change="changeList" color="#000000" title-inactive-color="#999999"  class="myTabs" title-active-colo="#000" line-width="16"  :ellipsis="false">
        <van-tab :title="item.category_name" v-for="(item, index) of catList" :key="index" >
          
        </van-tab>
      </van-tabs>
    <List
       style="padding-top: 21px;"
      :finished="finished"
      finished-text="没有更多了"
      @load="loadmore"
      class="content"
      v-if="list.length"
    >
      <BuyCard v-for="item of list" :key="item.id" :cardData="item"></BuyCard>
    </List>
    <div class="nodata" style="height: calc(100vh - 200rpx)" v-else>
      <img
        src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E8%B4%AD%E4%B9%B0%E8%AE%B0%E5%BD%95%402x.png"
        alt=""
      />
      <p>没有购买记录</p>
      <span>课程很好，下次一定</span>
    </div>
  </div>
</template>


<script>
import List from "vant/es/list/index";
import "vant/es/list/style/index";
import BuyCard from "@/components/BuyCardYingyou";
export default {
  components: {
    BuyCard,
    List,
  },
  computed: {},
  data() {
    return {
      page: 1,
      list: [],
      catList:[],
      loading: false,
      finished: false,
    };
  },
  computed: {
    plat() {
      return this.$store.state.plat_id;
    },
  },
  mounted(){
     this.getData()
  },
  methods: {
    async getData() {
      // this.pageLoading = true;

      this.$request.tuoyuCategory({ flat_id: this.plat }).then((res) => {
        console.log(res)
        this.catList = res.data
        this.changeList(this.catList[0].category_id)
      });
    },
    async changeList(index){
      let res = await this.$request.tuoyuBuy({category_id:this.catList[index].category_id,flat_id: this.plat})
        this.pageLoading = false;
        if(res.code == 0){
          this.list = res.data.courses
        } else {
          this.$toast(res.msg);
        }
        
    },
    loadmore(){

    }
  },
};
</script>

<style scoped>
.nodata{
  height: 60vh;
}
.list {
  min-height: 100vh;
  padding-top: 100px;
  box-sizing: border-box;
}
.myTabs{
  position: fixed;
  width: 100vw;
  top: 90px;
  left: 0;
  z-index: 100;
}
</style>